module.exports = __webpack_public_path__ + "static/img_shuangdan.07bad533.png";